export default __webpack_public_path__ + "static/media/n_wdt_c_5.5ee5be78.mp3";